import type { TranslationKey } from '../../i18n/he';

/*
 * ערכת צבעים.
 *
 * אובייקט הערכה הוא מקור האמת, ומשתני ה-CSS נכתבים ממנו (src/app/applyTheme.ts) —
 * ולא להפך. הסיבה: הקנבס לא יכול לקרוא משתני CSS, ושדה הקרב כולו מצויר בקנבס.
 * אם הצבעים היו חיים ב-CSS, ה-HUD ושדה הקרב היו נפרדים זה מזה בלי שנשים לב.
 *
 * ערכה חדשה = קובץ חדש כאן + שורה ב-THEMES.
 */

export type ThemeColorKey =
    | 'bg'
    | 'surface'
    | 'surfaceAlt'
    | 'border'
    | 'borderStrong'
    | 'text'
    | 'textMuted'
    | 'accent'
    | 'accentStrong'
    | 'success'
    | 'warning'
    | 'danger';

export interface Theme {
    readonly id: string;
    readonly nameKey: TranslationKey;
    readonly colors: Readonly<Record<ThemeColorKey, string>>;
    /** צבעי שחקנים לפי סדר משבצות. atlas הספרייטים נצבע מהם בעליית האפליקציה. */
    readonly playerColors: readonly string[];
}

export const crimson: Theme = {
    id: 'crimson',
    nameKey: 'theme_crimson',
    colors: {
        bg: '#0b0f14',
        surface: '#151b23',
        surfaceAlt: '#1e2733',
        border: '#2a3441',
        borderStrong: '#3d4a5c',
        text: '#cbd5e1',
        textMuted: '#64748b',
        accent: '#dc2626',
        accentStrong: '#ef4444',
        success: '#22c55e',
        warning: '#eab308',
        danger: '#ef4444',
    },
    playerColors: [
        '#3b82f6',
        '#dc2626',
        '#22c55e',
        '#eab308',
        '#a855f7',
        '#f97316',
        '#06b6d4',
        '#ec4899',
    ],
};

export const THEMES = [crimson] as const satisfies readonly Theme[];

export type ThemeId = (typeof THEMES)[number]['id'];

export const DEFAULT_THEME = crimson;
